import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import { NavPosLeft, NavPosRight } from "./leapChat.styles";
import { Button } from "@9amhealth/shared";

const HamburgerIcon: FC = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="3" y1="6" x2="21" y2="6" />
    <line x1="3" y1="12" x2="21" y2="12" />
    <line x1="3" y1="18" x2="21" y2="18" />
  </svg>
);

const PlusIcon: FC = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

export const ArchiveButton: FC = () => {
  const navigate = useNavigate();
  return (
    <NavPosLeft>
      <Button
        round
        onPress={() => navigate("/app/chat/archive")}
        theme="subtle"
        hideArrow
        outline
        icon={<HamburgerIcon />}
        size="medium"
        aria-label="View conversations"
      />
    </NavPosLeft>
  );
};

export const NewConversationButton: FC = () => {
  const navigate = useNavigate();
  return (
    <NavPosRight>
      <Button
        round
        onPress={() => navigate("/app/chat")}
        theme="subtle"
        outline
        hideArrow
        icon={<PlusIcon />}
        size="medium"
        aria-label="New conversation"
      />
    </NavPosRight>
  );
};
